/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { useAuth } from "@/context/AuthContext";
import { getUserDetails, updateUser } from "@/services/userApi";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  create_Subscriptions,
  upgrade_Subscriptions,
} from "@/services/subscriptionsApi";

const Checkout = () => {
  const navigate = useNavigate();

  const [plan, setCurrentPlan] = useState<any>(null);

  useEffect(() => {
    const storedCurrentPlan = localStorage.getItem("checkout_plan");

    if (storedCurrentPlan) {
      try {
        setCurrentPlan(JSON.parse(storedCurrentPlan));
        console.log(JSON.parse(storedCurrentPlan));
      } catch (error) {
        console.error("Invalid current_plan in localStorage", error);
        setCurrentPlan(null);
      }
    }
  }, []);

  const discountAmount =
    ((plan?.pricing ?? 0) * (plan?.discount_percentage ?? 0)) / 100;
  const [steps, setsteps] = useState<number>(1);
  const [loading, setLoading] = useState(true);

  const [duration, setDuration] = useState("monthly"); // default

  const [currentPlanId, setCurrentPlanId] = useState(null);

  useEffect(() => {
    console.log("Current Step:", steps);
  }, [steps]);

  const [responseStateName, setResponseStateName] = useState("");

  // Profile form state Tab 1
  const [f_name, setFName] = useState("");
  const [l_name, setLName] = useState("");
  const [company_name, setCompanyName] = useState("");
  const [mobile, setMobile] = useState("");
  const [address, setAddress] = useState("");
  const [pincode, setPincode] = useState("");
  const [profileImage, setProfileImage] = useState("");

  const formRef = useRef<HTMLFormElement>(null);

  // Account form state Tab 2
  const [email, setEmail] = useState("");
  const [emailVerified, setEmailVerified] = useState(true);
  const [alternateEmail, setAlternateEmail] = useState("");
  const [alternateEmailVerified, setAlternateEmailVerified] = useState(false);

  const [country, setCountry] = useState("");
  const [stateIso, setStateIso] = useState("");
  const [city, setCity] = useState("");

  const { user, refreshUser } = useAuth();
  const userId = user?.id;

  const fetchUser = async () => {
    try {
      if (!user?.id) return;
      const response = await getUserDetails(user.id);
      const u = response.value;

      // TAB 1 — Basic Profile
      setFName(u.f_name || "");
      setLName(u.l_name || "");
      setMobile(u.mobile || "");
      setAddress(u.address || "");
      setPincode(u.pincode || "");
      setProfileImage(u.profile_image || "");
      setCompanyName(u.company_details?.company_name || "");

      // Country → ISO conversion
      if (u.country) {
        setCountry(u.country);
      }

      // Store state name temporarily
      if (u.state) {
        setResponseStateName(u.state);
      }

      if (u.city) {
        setCity(u.city);
      }

      // TAB 2 — Account Settings
      setEmail(u.email || "");
      setEmailVerified(u.email_verified || false);
      setAlternateEmail(u.alternate_email || "");
      setAlternateEmailVerified(u.is_alternate_email_verified || false);
    } catch (err) {
      console.error("Profile fetch failed:", err);
    }
  };

  useEffect(() => {
    if (!user?.id) return;
    fetchUser();
  }, [user]);

  const handleProfileUpdate = async (e) => {
    e.preventDefault();

    // const stateObj = [];

    const payload = {
      f_name,
      l_name,
      mobile,
      address,
      pincode,
      company_name,
      country: country,
      state: responseStateName,
      city,
    };

    try {
      // 🚀 REMOVE EMPTY STRINGS
      Object.keys(payload).forEach((key) => {
        if (payload[key] === "" || payload[key] === null) {
          delete payload[key];
        }
      });

      const res = await updateUser(user.id, payload);
      // await refreshUser();
      setsteps(3);
      toast.success("Profile updated successfully");
    } catch (err) {
      toast.error("Failed to update profile");
    }
  };

  const handleSubscriptionPayment = async (subscriptionId, user, plan?) => {
    try {
      const options = {
        key: "rzp_live_SzUfhimk5oHXAW", // your key
        subscription_id: subscriptionId, // 🔥 IMPORTANT
        name: "Packtivate",
        description: "Subscription Payment",

        handler: function (response) {
          // setTimeout(() => {
          //   verifyWithRetry(response);
          // }, 5000); // ⏳ 5 seconds delay

          // location.href('thankyou');

          navigate("/thankyou", {
            state: { plan, paymentId: response?.razorpay_payment_id },
          });
        },

        prefill: {
          name: user.f_name + user.l_name,
          email: user.email,
          contact: user.mobile,
        },

        theme: {
          color: "#3399cc",
        },

        modal: {
          ondismiss: function () {
            console.log("Payment popup closed");
          },
        },
      };

      const rzp = new (window as any).Razorpay(options);
      rzp.open();
    } catch (error) {
      console.error("Payment error:", error);
    }
  };

  const loadRazorpay = () => {
    return new Promise((resolve) => {
      if ((window as any).Razorpay) {
        resolve(true);
      } else {
        const script = document.createElement("script");
        script.src = "https://checkout.razorpay.com/v1/checkout.js";
        script.onload = () => resolve(true);
        script.onerror = () => resolve(false);
        document.body.appendChild(script);
      }
    });
  };

  const handlePayment = async (plan) => {
    const isLoaded = await loadRazorpay();

    if (!isLoaded) {
      // alert("Razorpay SDK failed to load");
      return;
    }

    try {
      // 🔥 Call your backend

      let order = {};

      if (plan) {
        // Plan exists → check pricing
        if (plan.pricing === 0) {
          order = await create_Subscriptions(userId, plan._id);

          if (order["status"] == 200) {
            handleSubscriptionPayment(order["subscription_id"], user, plan);
          } else {
            toast.error(order["message"]);
          }
        } else {
          order = await upgrade_Subscriptions(userId, plan._id);

          if (order["status"] == 200) {
            handleSubscriptionPayment(order["subscription_id"], user, plan);
          } else {
            toast.error(order["message"]);
          }
        }
      } else {
        // No current plan → create new subscription
        order = await create_Subscriptions(userId, plan._id);

        if (order["status"] == 200) {
          handleSubscriptionPayment(order["subscription_id"], user, plan);
        } else {
          toast.error(order["message"]);
        }
      }

      //
    } catch (err) {
      console.error(err);
      // alert("Payment failed");
    }
  };

  return (
    <div className=" ">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="shop-breadcrumb">
              <div className="breadcrumb-main">
                <h4 className="text-capitalize breadcrumb-title">Checkout</h4>
                <div className="breadcrumb-action justify-content-center flex-wrap"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="cartPage  global-shadow border pr-sm-30 pl-sm-30  p-15 py-sm-30 bg-white radius-xl w-100 mb-30">
          <div className="row justify-content-center">
            <div className="cus-xl-9 col-12 ">
              {steps === 1 && (
                <>
                  <div className="product-cart mb-sm-0 mb-20">
                    <div className="table-responsive">
                      <table
                        id="cart"
                        className="table table-borderless table-hover"
                      >
                        <thead>
                          <tr className="product-cart__header">
                            <th scope="col">Plan Name</th>
                            <th scope="col">Price</th>
                            <th scope="col">Duration</th>
                            <th scope="col" className=""></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="Product-cart-title">
                              <div className="media  align-items-center">
                                <div className="media-body">
                                  <h1 className="mt-0">{plan?.name}</h1>
                                </div>
                              </div>
                            </td>
                            <td className="price">
                              ₹ {plan?.pricing?.toFixed(2)}
                            </td>
                            <td className="price"> {plan?.duration}</td>
                            {/* <td className="text-center subtotal">$5.11</td> */}
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="col-12 h-full">
                    <div className="button-group d-flex pt-10 mb-20 justify-content-between flex-wrap">
                      <button
                        type="button"
                        disabled={steps <= 1}
                        onClick={() =>
                          setsteps((prev) => Math.max(1, prev - 1))
                        }
                        className="btn btn-light btn-default btn-squared fw-400 text-capitalize m-1"
                      >
                        <i className="las la-arrow-left mr-10"></i>
                        Previous
                      </button>

                      <button
                        type="button"
                        disabled={steps >= 3}
                        onClick={() =>
                          setsteps((prev) => Math.min(3, prev + 1))
                        }
                        className="btn text-white btn-primary btn-default btn-squared text-capitalize m-1"
                      >
                        Next
                        <i className="ml-10 mr-0 las la-arrow-right"></i>
                      </button>
                    </div>
                  </div>
                </>
              )}
              {steps === 2 && (
                <>
                  <div className="row justify-content-center">
                    <div className="col-xl-6 col-lg-8 col-sm-10">
                      <div className="card   border-0">
                        <div className="card-body">
                          <div className="edit-profile__body">
                            <form ref={formRef} onSubmit={handleProfileUpdate}>
                              {/* First Name */}
                              <div className="form-group mb-20">
                                <label htmlFor="f_name">First Name</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="f_name"
                                  placeholder="Enter first name"
                                  value={f_name}
                                  onChange={(e) => setFName(e.target.value)}
                                />
                              </div>

                              {/* Last Name */}
                              <div className="form-group mb-20">
                                <label htmlFor="l_name">Last Name</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="l_name"
                                  placeholder="Enter last name"
                                  value={l_name}
                                  onChange={(e) => setLName(e.target.value)}
                                />
                              </div>

                              <div className="form-group mb-20">
                                <label htmlFor="company_name">
                                  Company Name
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="company_name"
                                  placeholder="Enter company name"
                                  value={company_name}
                                  onChange={(e) =>
                                    setCompanyName(e.target.value)
                                  }
                                />
                              </div>

                              {/* Mobile */}
                              <div className="form-group mb-20">
                                <label htmlFor="mobile">Mobile Number</label>
                                <input
                                  type="tel"
                                  className="form-control"
                                  id="mobile"
                                  readOnly
                                  placeholder="+91 9876543210"
                                  value={mobile}
                                  onChange={(e) => setMobile(e.target.value)}
                                />
                              </div>

                              {/* Address */}
                              <div className="form-group mb-20">
                                <label htmlFor="address">Address</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="address"
                                  placeholder="Enter address"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                />
                              </div>

                              {/* Pincode */}
                              <div className="form-group mb-20">
                                <label htmlFor="pincode">Pincode</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  required
                                  id="pincode"
                                  placeholder="Enter pincode"
                                  value={pincode}
                                  onChange={(e) => setPincode(e.target.value)}
                                />
                              </div>

                              {/* COUNTRY DROPDOWN */}
                              <div className="form-group mb-20">
                                <label htmlFor="countryOption">Country</label>
                                {/* <select
                                  className="form-control"
                                  id="countryOption"
                                  value={country}
                                  onChange={(e) => {
                                    setCountry(e.target.value);
                                    setStateIso("");
                                    setCity("");
                                  }}
                                >
                                  <option value="">Select Country</option>
                                  {countries.map((c) => (
                                    <option key={c.isoCode} value={c.isoCode}>
                                      {c.name}
                                    </option>
                                  ))}
                                </select> */}

                                <input
                                  type="text"
                                  className="form-control"
                                  required
                                  id="country"
                                  placeholder="Enter country"
                                  value={country}
                                  onChange={(e) => setCountry(e.target.value)}
                                />
                              </div>

                              {/* STATE DROPDOWN */}
                              <div className="form-group mb-20">
                                <label htmlFor="stateOption">State</label>

                                <input
                                  type="text"
                                  className="form-control"
                                  required
                                  id="state"
                                  placeholder="Enter state"
                                  value={responseStateName}
                                  onChange={(e) =>
                                    setResponseStateName(e.target.value)
                                  }
                                />

                                {/* <select
                                  className="form-control"
                                  id="stateOption"
                                  value={stateIso}
                                  onChange={(e) => {
                                    setStateIso(e.target.value);
                                    setCity("");
                                  }}
                                  disabled={!country}
                                >
                                  <option value="">Select State</option>
                                  {states.map((s) => (
                                    <option key={s.isoCode} value={s.isoCode}>
                                      {s.name}
                                    </option>
                                  ))}
                                </select> */}
                              </div>

                              {/* CITY DROPDOWN */}
                              <div className="form-group mb-20">
                                <label htmlFor="cityOption">City</label>

                                <input
                                  type="text"
                                  className="form-control"
                                  required
                                  id="city"
                                  placeholder="Enter city"
                                  value={city}
                                  onChange={(e) => setCity(e.target.value)}
                                />
                                {/* <select
                                  className="form-control"
                                  id="cityOption"
                                  value={city}
                                  onChange={(e) => setCity(e.target.value)}
                                  disabled={!stateIso}
                                >
                                  <option value="">Select City</option>
                                  {cities.map((ct) => (
                                    <option key={ct.name} value={ct.name}>
                                      {ct.name}
                                    </option>
                                  ))}
                                </select> */}
                              </div>
                              <div className="col-12 h-full">
                                <div className="button-group d-flex pt-10 mb-20 justify-content-between flex-wrap">
                                  <button
                                    type="button"
                                    disabled={steps <= 1}
                                    onClick={() =>
                                      setsteps((prev) => Math.max(1, prev - 1))
                                    }
                                    className="btn btn-light btn-default btn-squared fw-400 text-capitalize m-1"
                                  >
                                    <i className="las la-arrow-left mr-10"></i>
                                    Previous
                                  </button>

                                  <button
                                    type="button"
                                    disabled={steps >= 3}
                                    onClick={() => {
                                      if (steps === 2) {
                                        // Submit the form
                                        formRef.current?.requestSubmit();
                                        // setsteps(3);
                                      }
                                    }}
                                    className="btn text-white btn-primary btn-default btn-squared text-capitalize m-1"
                                  >
                                    Next
                                    <i className="ml-10 mr-0 las la-arrow-right"></i>
                                  </button>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {steps === 3 && (
                <>
                  <div className="container-fluid">
                    <div className=" global-shadow checkout-review border p-sm-50 p-20 mb-50 bg-white radius-xl w-100">
                      <div className="row">
                        <div className="col-12">
                          <div className="row justify-content-center">
                            <div className="col-xl-12">
                              <div className="card crc bg-normal p-sm-30 p-15">
                                <div className="card-body mb-30 bg-white bg-shadow radius-xl px-sm-30 px-15 pt-25  mb-30">
                                  <div className="crc__title mb-30">
                                    <h5 className="color-gray">Information</h5>
                                    <span className="color"></span>
                                    <button
                                      type="submit"
                                      className="border-0 crc__title-btn shadow-none bg-transparent color-info content-center fs-14"
                                      onClick={() =>
                                        setsteps((prev) =>
                                          Math.max(1, prev - 1),
                                        )
                                      }
                                    >
                                      <span data-feather="edit"></span>edit
                                    </button>
                                  </div>
                                  <div className="d-flex mb-10">
                                    <div className="radio-theme-default custom-radio   mr-2">
                                      <input
                                        className="radio"
                                        type="radio"
                                        name="radio-vertical"
                                        value={0}
                                        id="radio-vl5"
                                        checked={true}
                                        readOnly
                                      />
                                      <label htmlFor="radio-vl5">
                                        <span className="radio-text"></span>
                                      </label>
                                    </div>

                                    <div className="check-review__contact">
                                      <p>
                                        {f_name} {l_name} <br /> Phone: {mobile}
                                      </p>
                                      <span>
                                        {address} {pincode}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="cus-xl-3 col-md-8  ">
              <div className="card order-summery bg-normal p-sm-25 p-15 order-summery--width ">
                <div className="card-header border-bottom-0 p-0 pb-25">
                  <h5 className="fw-500">Order Summary</h5>
                </div>
                <div className="card-body bg-white px-sm-25 px-20">
                  <div className="total">
                    <div className="subtotalTotal">
                      Subtotal:
                      <span>₹ {plan?.price_before_discount?.toFixed(2)}</span>
                    </div>
                    {discountAmount > 0 && (
                      <div className="taxes">
                        discount:
                        <span>₹ {discountAmount?.toFixed(2)}</span>
                      </div>
                    )}
                  </div>

                  <div className="total-money d-flex justify-content-between">
                    <h6>Total :</h6>
                    <h5>₹ {plan?.pricing?.toFixed(2)}</h5>
                  </div>
                  {steps === 3 && (
                    <div className="mt-3">
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          // setsteps(2);
                          handlePayment(plan);
                        }}
                        className="checkout btn-secondary content-center w-100 btn-lg mt-20"
                      >
                        proceed to checkout
                        <i className="las la-arrow-right"></i>
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Checkout;
